var map = {
	"./add-protocol.svg": 12367,
	"./agenda-drag-locked.svg": 5131,
	"./agenda-drag-unlocked.svg": 58522,
	"./bip-simple.svg": 62457,
	"./building-columns.svg": 40691,
	"./camera-web.svg": 99189,
	"./delete.svg": 86956,
	"./display.svg": 933,
	"./download-black.svg": 65767,
	"./download.svg": 46489,
	"./duplicate.svg": 98128,
	"./edit-session-list.svg": 44479,
	"./export-to-doc.svg": 83150,
	"./lock-open.svg": 30081,
	"./lock.svg": 28328,
	"./paper-plane-top-regular.svg": 19213,
	"./pen-to-square.svg": 12220,
	"./play.svg": 17463,
	"./record-vinyl.svg": 87401,
	"./robot.svg": 68831,
	"./rotate-left.svg": 8790,
	"./rotate-right.svg": 84053,
	"./save.svg": 38966,
	"./settings.svg": 66462,
	"./tablet-rugged.svg": 90032,
	"./timer.svg": 35236,
	"./tooltip.svg": 26154,
	"./user-check-presence.svg": 62991,
	"./video-arrow-up-right.svg": 88021,
	"./voting.svg": 88400,
	"./wallet.svg": 67766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8371;